import * as React from 'react';
import { ScoreboardTabel } from '../../models/ScoreboardTabel';
import ScoreboardRow from './ScoreboardRow';
import { Row, Col } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { Icon } from '../../uiComponents/Icon';
import * as FlipMove from 'react-flip-move';
import { EmptyState } from '../../uiComponents/EmptyState';
import { KonkurrenceResultat } from '../../models/KonkurrenceResultat';

export interface ScoreboardTabelPresenterProps {
    konkurrenceResultatTabel: ScoreboardTabel;
    sortedColumnName: string;
    onClose: () => void;
    onColHeaderClick: (colName: string) => void;
    showSamletPlacering: boolean;
    resultaterToShow: KonkurrenceResultat[];
}

export default class ScoreboardTabelPresenter extends React.Component<ScoreboardTabelPresenterProps, any> {
    renderColHeader(text: string, colName: string) {
        let className = '';
        if (this.props.sortedColumnName === colName) {
            className = 'sorted-by';
        }

        return (
            <h2 onClick={() => this.props.onColHeaderClick(colName)} className={className}>
                {text}
            </h2>
        );
    }

    render() {
        if (this.props.konkurrenceResultatTabel.ingenKonfiguration) {
            return (
                <EmptyState header='Der er ikke nogen resultater at vise' />
            );
        } else {
            let bootstrapCols = 2;
            if (this.props.konkurrenceResultatTabel.resultater[0].opgaveDelopgavePlaceringer.length > 3) {
                bootstrapCols = 1;
            }

            const delopgaver = this.props.konkurrenceResultatTabel.resultater[0].opgaveDelopgavePlaceringer.map((placering, c) => {
                return (
                    <Col key={c} md={bootstrapCols}>
                        {this.renderColHeader(placering.navn, placering.id)}
                    </Col>
                );
            }
            );

            const rows = this.props.resultaterToShow.map((resultat, i) => {
                return (
                    <ScoreboardRow
                        key={i}
                        samletPlacering={resultat.samletPlacering}
                        holdnavn={resultat.holdNavn}
                        institution={resultat.institution}
                        opgaveDelopgavePlaceringer={resultat.opgaveDelopgavePlaceringer}
                        sortedColumnName={this.props.sortedColumnName}
                        bootstrapCols={bootstrapCols}
                        showSamletPlacering={this.props.showSamletPlacering}
                        samletAntalPoint={resultat.samletAntalPoint}
                    />
                );
            });

            const samletPlaceringHeader = this.props.showSamletPlacering ? (
                <div className='left-align'>
                    {this.renderColHeader('Samlet placering', 'samlet')}
                </div>) : undefined;

            const holdHeader = (
                <Col md={2}>
                    <div className='left-align'>
                        {this.renderColHeader('Hold', 'hold')}
                    </div>
                </Col>
            );

            const rowsWithFlitMove = (
                <FlipMove disableAllAnimations={true} >
                    {rows}
                </FlipMove>
            );

            return (
                <div id='scoreboard'>
                    <ContentWrapper>
                        <div className='header'>
                            <Row>
                                <Col md={10} className='header-wrapper'>
                                    <h1>{this.props.konkurrenceResultatTabel.overskrift}</h1>
                                </Col>
                                <Col md={2} className='pull-right'>
                                    <Icon className='icon' name='close' onClick={() => this.props.onClose()} />
                                </Col>
                            </Row>
                        </div>

                        <div className='col-headers'>
                            <Row>
                                <Col md={3} className='left-column'>
                                    {samletPlaceringHeader}
                                </Col>
                                {holdHeader}
                                {delopgaver}
                            </Row>
                        </div>

                        {rowsWithFlitMove}
                    </ContentWrapper>
                </div>
            );
        }
    }
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/Scoreboard/ScoreboardTabelPresenter.tsx